// ============================================================================
// page-service / hero.js
// ----------------------------------------------------------------------------
// Hero SCROLL button: smooth-scrolls to the .service-content section.
// ============================================================================

document.addEventListener("DOMContentLoaded", function () {
  const scrollButton = document.querySelector(".services__button");
  const target = document.querySelector(".service-content");

  if (!scrollButton || !target) return;

  scrollButton.addEventListener("click", function () {
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });
});
